import { useEffect, useState } from "react";

interface ISize {
  width: number;
  height: number;
}

const Size: ISize = { width: window.innerWidth, height: window.innerHeight };

export default function useWindowSize(): ISize {
  const [size, setSize] = useState<ISize>(Size);

  const handleSetHeight = () => setSize({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    window.addEventListener("resize", handleSetHeight);

    return () => {
      window.removeEventListener("resize", handleSetHeight);
    };
  }, []);

  return size;
}
